<template>
  <div class="box" :style="{'background-color':getThemeColor}">
    <span v-if="!hasProduct()">No products :/</span>
    <div v-for="(product, index) in getProductsInCart"  :key="index" class="box-item"
    :style="{'background-color':getThemeColor,'color':getSecondaryColor}">
      <img :src="product.image" alt="" class="item-thumb">
      <h3 class="item-name">{{ product.name }}</h3>
      <span class="item-amount">Quantity: 1</span>
      <span class="item-price">{{getCurrency}} {{ product.price }}</span>
    </div>
    <div class="cart-info" v-if="hasProduct()">
      <span>Total: {{getCurrency}} {{ totalPrice() }}, 00</span>
      <router-link to="/checkout">
        <btn btnColor="btn btn-small btn-info"
          @click.native="showPopupCart()">
          View cart
        </btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import btn from '@/components/BitsCart/Btn.vue';

export default {
  components: {
    btn,
  },
  methods: {
    ...mapActions([
      'showOrHiddenPopupCart',
    ]),
    hasProduct() {
      return this.getProductsInCart.length > 0;
    },
    totalPrice() {
      return this.getProductsInCart.reduce((current, next) =>
        current + next.price, 0);
    },
    showPopupCart() {
      this.showOrHiddenPopupCart();
    },
  },
  computed: {
    ...mapGetters([
      'getProductsInCart',
      'getCurrency',
      'getThemeColor',
      'getSecondaryColor'
    ]),
  },
};
</script>

<style scoped>
  .box {
    width: 400px;
    height: auto;
    background-color: #FAFAFA;
    box-shadow: 0px 0px 10px rgba(73, 74, 78, 0.1);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 1em .5em;
    position: absolute;
    z-index: 1;
  }

  .box:after {
    content: '';
    width: 30px;
    height: 30px;
    transform: rotate(45deg);
    background: inherit;
    position: absolute;
    top: -15px;
    right: 15px;
  }

  .box-item {
    width: 100%;
    height: 130px;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0 .5em;
    margin-top: .3em;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }

  .item-thumb {
    max-width: 70%;
    grid-column: 1/2;
    grid-row: 1/4;
    align-self: center;
  }

  .item-name {
    grid-column: 2/4;
    grid-row: 1/2;
    font-weight: normal;
    font-size: 14px;
  }

  .item-amount {
    grid-column: 2/3;
    grid-row: 2/4;
    color: #ddd;
    font-size: 14px;
  }

  .cart-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

</style>
